import { render, staticRenderFns } from "./inplay.vue?vue&type=template&id=69949546&scoped=true"
import script from "./inplay.vue?vue&type=script&lang=js"
export * from "./inplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69949546",
  null
  
)

export default component.exports